import { use } from 'react'
import { OTPForm } from '../OTPForm'
import { LoginContext } from '../../contexts/Login'
import { TOTP as TOTP_TYPE } from 'mfa'

export const TOTP = (props) => (
  <OTPForm
    {...props}
    icon='phonelink_lock'
    iconColor='green600'
    titleKey='totp'
    labelKey='totp.verificationCode'
    mfaType={TOTP_TYPE}
    fieldName='totp'
    fieldId='totp-code'
  />
)

const TOTPWithContext = (props) => {
  const ctx = use(LoginContext)
  return <TOTP ctx={ctx} {...props} />
}
TOTPWithContext.displayName = 'TOTP'

export default TOTPWithContext
